export const iconFontAwesomeBuildingsPlaceOfWorship = (
	<i className="fa-solid fa-place-of-worship"></i>
);
